.root { display: flex; flex-direction: column; gap: var(--sp-8); }

/* ── Header ──────────────────────────────────────────────────── */
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--sp-8);
}

.title {
  font-family: var(--font-mono);
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.sub { font-size: 13px; color: var(--color-text-muted); margin-top: var(--sp-1); }

.stats { display: flex; align-items: center; gap: var(--sp-5); }

.stat { display: flex; flex-direction: column; align-items: center; gap: 2px; }

.statVal {
  font-family: var(--font-mono);
  font-size: 28px;
  font-weight: 700;
  background: var(--grad-brand);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.statLabel {
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 1.5px;
  color: var(--color-text-muted);
  text-transform: uppercase;
}

.statDivider { width: 1px; height: 36px; background: var(--color-border); }

/* ── Error banner ────────────────────────────────────────────── */
.errorBanner {
  display: flex;
  align-items: center;
  gap: var(--sp-4);
  padding: var(--sp-3) var(--sp-5);
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: var(--radius-md);
  font-size: 13px;
  color: var(--color-error);
}

.retryBtn {
  margin-left: auto;
  font-family: var(--font-mono);
  font-size: 11px;
  padding: 3px 10px;
  border-radius: var(--radius-sm);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: var(--color-error);
  background: transparent;
  cursor: pointer;
}

.retryBtn:hover { background: rgba(239, 68, 68, 0.1); }

/* ── Section ─────────────────────────────────────────────────── */
.section { display: flex; flex-direction: column; gap: var(--sp-4); }

.sectionLabel {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2px;
  color: var(--color-text-muted);
  text-transform: uppercase;
}

.layerTag {
  font-family: var(--font-mono);
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 3px;
  background: rgba(56, 189, 248, 0.1);
  border: 1px solid rgba(56, 189, 248, 0.2);
  color: var(--color-sky);
  letter-spacing: 1.5px;
}

/* ── Grid ────────────────────────────────────────────────────── */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: var(--sp-4);
}

/* ── Cards ───────────────────────────────────────────────────── */
.card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: var(--sp-5);
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.card:hover { border-color: var(--color-border-med); }

.card.connected { border-left: 3px solid var(--color-success); }
.card.syncing,
.card.pending   { border-left: 3px solid var(--color-warn); }
.cardError      { border-left: 3px solid var(--color-error) !important; }
.card.available { opacity: 0.65; }
.card.available:hover { opacity: 1; }

.cardTop {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.cardIcon {
  font-size: 22px;
  color: var(--color-sky-dim);
  line-height: 1;
}

.cardName {
  font-family: var(--font-mono);
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text);
}

.cardCategory { font-size: 12px; color: var(--color-text-muted); }

.errorMsg {
  font-size: 11px;
  color: var(--color-error);
  background: rgba(239, 68, 68, 0.06);
  border-radius: var(--radius-sm);
  padding: var(--sp-2) var(--sp-3);
}

.defJobBadge {
  font-family: var(--font-mono); font-size: 9px; font-weight: 700; letter-spacing: 0.06em;
  text-transform: uppercase; padding: 2px 8px; border-radius: 3px; align-self: flex-start;
  background: rgba(56,189,248,0.08); border: 1px solid rgba(56,189,248,0.2);
  color: var(--color-sky);
  animation: defPulse 1.6s ease-in-out infinite;
}
.defJobBadgeDone {
  background: rgba(45,212,191,0.08); border-color: rgba(45,212,191,0.2);
  color: var(--color-teal-bright); animation: none;
}
.defJobBadgeFail {
  background: rgba(239,68,68,0.08); border-color: rgba(239,68,68,0.2);
  color: var(--color-error); animation: none;
}
@keyframes defPulse {
  0%, 100% { opacity: 1; } 50% { opacity: 0.45; }
}

.cardFooter {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  flex-wrap: wrap;
  margin-top: auto;
}

.cardSync {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-faint);
  flex: 1;
}

.cardRows {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-muted);
}

/* ── Status badge ────────────────────────────────────────────── */
.badge {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  padding: 2px 7px;
  border-radius: var(--radius-sm);
}

.badgeConnected {
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.2);
  color: var(--color-success);
}

.badgeSyncing {
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.2);
  color: var(--color-warn);
}

.badgeError {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  color: var(--color-error);
}

/* ── Re-auth warning ─────────────────────────────────────────── */
.reAuthRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-2);
  margin-top: var(--sp-2);
  padding: 6px 8px;
  background: rgba(245, 158, 11, 0.08);
  border: 1px solid rgba(245, 158, 11, 0.2);
  border-radius: var(--radius-sm);
}

.reAuthBanner {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  color: var(--color-warn);
  letter-spacing: 0.3px;
}

.reAuthBtn {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 700;
  color: var(--color-warn);
  background: none;
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: var(--radius-sm);
  padding: 2px 8px;
  cursor: pointer;
  white-space: nowrap;
}
.reAuthBtn:hover:not(:disabled) { background: rgba(245, 158, 11, 0.12); }
.reAuthBtn:disabled { opacity: 0.5; cursor: default; }

/* ── Data Wizard button ──────────────────────────────────────── */
.wizardBtn {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  padding: var(--sp-1) var(--sp-3);
  border-radius: var(--radius-sm);
  background: rgba(139, 92, 246, 0.08);
  border: 1px solid rgba(139, 92, 246, 0.2);
  color: #a78bfa;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  white-space: nowrap;
}
.wizardBtn:hover:not(:disabled) {
  background: rgba(139, 92, 246, 0.16);
  border-color: rgba(139, 92, 246, 0.4);
  color: #c4b5fd;
}
.wizardBtn:disabled { opacity: 0.5; cursor: default; }
.wizardBtnLg {
  padding: var(--sp-2) var(--sp-4);
  font-size: 12px;
}
.wizardBtnRunning {
  animation: defPulse 1.6s ease-in-out infinite;
  border-color: rgba(56, 189, 248, 0.25);
  background: rgba(56, 189, 248, 0.08);
  color: var(--color-sky);
}
.wizardBtnDone {
  border-color: rgba(45, 212, 191, 0.25);
  background: rgba(45, 212, 191, 0.08);
  color: var(--color-teal-bright);
  animation: none;
}
.wizardBtnFail {
  border-color: rgba(239, 68, 68, 0.25);
  background: rgba(239, 68, 68, 0.08);
  color: var(--color-error);
  animation: none;
}

/* ── Sync button ─────────────────────────────────────────────── */
.syncBtn {
  font-family: var(--font-mono);
  font-size: 14px;
  width: 28px;
  height: 28px;
  border-radius: var(--radius-sm);
  background: rgba(56, 189, 248, 0.08);
  border: 1px solid rgba(56, 189, 248, 0.15);
  color: var(--color-sky-dim);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.syncBtn:hover:not(:disabled) {
  background: rgba(56, 189, 248, 0.16);
  color: var(--color-sky);
}

.syncBtn:disabled { opacity: 0.4; cursor: default; }
.syncBtnBusy { animation: spin 1s linear infinite; }

/* Larger sync button variant used in the detail header */
.syncBtnLg {
  width: auto;
  height: auto;
  padding: var(--sp-2) var(--sp-4);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.4px;
  gap: var(--sp-2);
}

.syncGroup {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
}

.fullRefreshBtn {
  font-family: var(--font-mono);
  font-size: 12px;
  background: none;
  border: none;
  color: var(--color-text-muted);
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: color 0.15s;
}

.fullRefreshBtn:hover {
  color: var(--color-text-dim);
}

@keyframes spin { to { transform: rotate(360deg); } }

/* ── Sync progress bar ───────────────────────────────────────── */
.syncProgress {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 140px;
}

.syncProgressLg {
  min-width: 200px;
}

.syncProgressTrack {
  height: 4px;
  background: rgba(56, 189, 248, 0.12);
  border-radius: 2px;
  overflow: hidden;
}

.syncProgressFill {
  height: 100%;
  background: linear-gradient(90deg, rgba(56, 189, 248, 0.6), #38bdf8);
  border-radius: 2px;
  transition: width 1s ease;
}

.syncProgressFillSuccess {
  background: #22c55e;
  transition: width 0.3s ease;
}

.syncProgressFillError {
  background: #ef4444;
  transition: width 0.3s ease;
}

.syncProgressLabel {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-muted);
  letter-spacing: 0.3px;
}

.syncProgressLabelSuccess { color: #22c55e; }
.syncProgressLabelError   { color: #ef4444; }

.syncProgressErrorMsg {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-error, #ef4444);
  opacity: 0.8;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
}

.historyErrorMsg {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-error, #ef4444);
  opacity: 0.75;
  margin-top: 4px;
  max-width: 320px;
}

/* ── Browse button ───────────────────────────────────────────── */
.browseBtn {
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: var(--sp-2) var(--sp-5);
  border-radius: var(--radius-sm);
  background: rgba(56, 189, 248, 0.1);
  border: 1px solid rgba(56, 189, 248, 0.25);
  color: var(--color-sky);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  white-space: nowrap;
}

.browseBtn:hover {
  background: rgba(56, 189, 248, 0.18);
  border-color: rgba(56, 189, 248, 0.45);
}

/* ── Connect button ──────────────────────────────────────────── */
.connectBtn {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 4px 10px;
  border-radius: var(--radius-sm);
  background: rgba(56, 189, 248, 0.1);
  border: 1px solid rgba(56, 189, 248, 0.2);
  color: var(--color-sky);
  transition: background 0.15s, border-color 0.15s;
  cursor: pointer;
}

.connectBtn:hover {
  background: rgba(56, 189, 248, 0.18);
  border-color: rgba(56, 189, 248, 0.4);
}

/* ── Empty state ─────────────────────────────────────────────── */
.emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-4);
  padding: var(--sp-12) var(--sp-8);
  border: 1px dashed var(--color-border);
  border-radius: var(--radius-lg);
  text-align: center;
}

.emptyIcon { font-size: 32px; color: var(--color-text-faint); }

.emptyText { font-size: 14px; color: var(--color-text-muted); }

.emptyBtn {
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 600;
  padding: var(--sp-2) var(--sp-5);
  border-radius: var(--radius-sm);
  background: rgba(56, 189, 248, 0.1);
  border: 1px solid rgba(56, 189, 248, 0.25);
  color: var(--color-sky);
  cursor: pointer;
  transition: background 0.15s;
}

.emptyBtn:hover { background: rgba(56, 189, 248, 0.18); }

/* ── Skeleton ────────────────────────────────────────────────── */
.skeleton {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: var(--sp-5);
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

.skeletonLine {
  background: linear-gradient(
    90deg,
    rgba(56, 189, 248, 0.04) 25%,
    rgba(56, 189, 248, 0.09) 50%,
    rgba(56, 189, 248, 0.04) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.6s ease infinite;
  border-radius: var(--radius-sm);
}

.skeletonIcon  { width: 28px; height: 28px; border-radius: 50%; }
.skeletonTitle { height: 14px; width: 70%; }
.skeletonSub   { height: 11px; width: 45%; }

@keyframes shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Connector Detail ────────────────────────────────────────── */
.detailRoot {
  display: flex;
  flex-direction: column;
  gap: var(--sp-6);
}

/* Detail header row */
.detailHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--sp-6);
  flex-wrap: wrap;
}

.detailHeaderLeft {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

.backBtn {
  background: none;
  border: none;
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--color-text-muted);
  cursor: pointer;
  padding: 0;
  width: fit-content;
  transition: color 0.15s;
}

.backBtn:hover { color: var(--color-sky); }

.detailTitleRow {
  display: flex;
  align-items: center;
  gap: var(--sp-4);
  flex-wrap: wrap;
}

.detailIcon {
  font-size: 32px;
  color: var(--color-sky-dim);
  line-height: 1;
  flex-shrink: 0;
}

.detailName {
  font-family: var(--font-mono);
  font-size: 18px;
  font-weight: 700;
  color: var(--color-text);
}

.detailCategory {
  font-size: 12px;
  color: var(--color-text-muted);
  display: block;
  margin-top: 2px;
}

/* Actions cluster */
.detailActions {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  flex-shrink: 0;
  flex-wrap: wrap;
}

.disconnectBtn {
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.4px;
  padding: var(--sp-2) var(--sp-4);
  border-radius: var(--radius-sm);
  background: transparent;
  border: 1px solid rgba(239, 68, 68, 0.2);
  color: var(--color-error);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.disconnectBtn:hover {
  background: rgba(239, 68, 68, 0.08);
  border-color: rgba(239, 68, 68, 0.35);
}

.disconnectConfirm {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  padding: var(--sp-2) var(--sp-3);
  border: 1px solid rgba(239, 68, 68, 0.25);
  border-radius: var(--radius-sm);
  background: rgba(239, 68, 68, 0.06);
}

.disconnectWarning {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--color-error);
  white-space: nowrap;
}

.disconnectConfirmBtn {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: var(--radius-sm);
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.35);
  color: var(--color-error);
  cursor: pointer;
  transition: background 0.15s;
}

.disconnectConfirmBtn:hover { background: rgba(239, 68, 68, 0.25); }

.disconnectCancelBtn {
  font-family: var(--font-mono);
  font-size: 11px;
  padding: 3px 10px;
  border-radius: var(--radius-sm);
  background: transparent;
  border: 1px solid var(--color-border);
  color: var(--color-text-muted);
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
}

.disconnectCancelBtn:hover {
  border-color: var(--color-border-med);
  color: var(--color-text);
}

/* ── Stats strip ─────────────────────────────────────────────── */
.statsStrip {
  display: flex;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface);
  overflow: hidden;
}

.statBox {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  padding: var(--sp-5) var(--sp-6);
  border-right: 1px solid var(--color-border);
}

.statBoxLast {
  border-right: none;
}

.statBoxVal {
  font-family: var(--font-mono);
  font-size: 15px;
  font-weight: 700;
  color: var(--color-text);
}

.statBoxLabel {
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 1.5px;
  color: var(--color-text-muted);
  text-transform: uppercase;
}

/* ── Detail sections ─────────────────────────────────────────── */
.detailSection {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
}

/* ── History / tables table ──────────────────────────────────── */
.tableWrap {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.historyTable {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.historyTable thead tr {
  border-bottom: 1px solid var(--color-border-med);
}

.historyTable th {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1.5px;
  color: var(--color-text-faint);
  text-transform: uppercase;
  text-align: left;
  padding: var(--sp-3) var(--sp-4);
}

.historyTable td {
  padding: var(--sp-3) var(--sp-4);
  border-bottom: 1px solid var(--color-border);
  vertical-align: middle;
}

.historyTable tbody tr:last-child td {
  border-bottom: none;
}

.historyTable tbody tr:hover td {
  background: rgba(56, 189, 248, 0.03);
}

.historyRowLive td {
  background: rgba(56, 189, 248, 0.04);
}

.historyRowLive:hover td {
  background: rgba(56, 189, 248, 0.07);
}

.monoCell {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--color-text-muted);
}

.tableName {
  color: var(--color-text);
  font-weight: 600;
}

/* ── History status pills ────────────────────────────────────── */
.historyPill {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 20px;
  text-transform: lowercase;
  letter-spacing: 0.3px;
}

.historyPill_success {
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.2);
  color: var(--color-success);
}

.historyPill_partial {
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.2);
  color: var(--color-warn);
}

.historyPill_error {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  color: var(--color-error);
}

/* ── Source Manifest ─────────────────────────────────────────── */
.manifestDesc {
  font-size: 13px;
  color: var(--color-text-muted);
  margin: 0;
  line-height: 1.6;
}

.manifestList {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

.manifestRow {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  overflow: hidden;
  transition: border-color 0.15s;
}

.manifestRow:hover { border-color: var(--color-border-med); }

.manifestRowTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--sp-3) var(--sp-4);
  gap: var(--sp-3);
}

.manifestRowLeft {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  min-width: 0;
  flex: 1;
}

.manifestExpandBtn {
  background: none;
  border: none;
  font-size: 12px;
  color: var(--color-text-faint);
  cursor: pointer;
  padding: 0;
  width: 16px;
  flex-shrink: 0;
  transition: color 0.15s;
}

.manifestExpandBtn:hover { color: var(--color-sky); }

.manifestTableName {
  font-family: var(--font-mono);
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.manifestRows {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-muted);
  background: rgba(56, 189, 248, 0.06);
  border: 1px solid rgba(56, 189, 248, 0.12);
  border-radius: 999px;
  padding: 1px 8px;
  white-space: nowrap;
  flex-shrink: 0;
}

.manifestSynced {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-faint);
  white-space: nowrap;
  flex-shrink: 0;
}

.manifestRowActions {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  flex-shrink: 0;
}

.exploreBtn {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: var(--radius-sm);
  background: rgba(56, 189, 248, 0.08);
  border: 1px solid rgba(56, 189, 248, 0.18);
  color: var(--color-sky);
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.15s, border-color 0.15s;
}

.exploreBtn:hover {
  background: rgba(56, 189, 248, 0.16);
  border-color: rgba(56, 189, 248, 0.35);
}

.prepareAllBtn {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: var(--radius-sm);
  background: rgba(13, 148, 136, 0.08);
  border: 1px solid rgba(13, 148, 136, 0.22);
  color: #2dd4bf;
  cursor: pointer;
  white-space: nowrap;
  margin-left: auto;
  letter-spacing: 0;
  text-transform: none;
  transition: background 0.15s, border-color 0.15s;
}

.prepareAllBtn:hover {
  background: rgba(13, 148, 136, 0.16);
  border-color: rgba(13, 148, 136, 0.4);
}

.stageBtn {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: var(--radius-sm);
  background: rgba(13, 148, 136, 0.08);
  border: 1px solid rgba(13, 148, 136, 0.22);
  color: #2dd4bf;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.15s, border-color 0.15s;
}

.stageBtn:hover {
  background: rgba(13, 148, 136, 0.16);
  border-color: rgba(13, 148, 136, 0.4);
}

.colChipModel {
  font-family: var(--font-mono);
  font-size: 11px;
  color: #2dd4bf;
  background: rgba(13, 148, 136, 0.08);
  border: 1px solid rgba(13, 148, 136, 0.2);
  border-radius: var(--radius-sm);
  padding: 2px 7px;
  font-style: italic;
}

.manifestColumns {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
  padding: var(--sp-3) var(--sp-4);
  padding-top: 0;
  padding-left: calc(var(--sp-4) + 16px + var(--sp-3));
  border-top: 1px solid var(--color-border);
  background: rgba(56, 189, 248, 0.02);
}

.colChip {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-faint);
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  padding: 2px 7px;
}

/* ── AI CTA panel ────────────────────────────────────────────── */
.aiPanel {
  background: var(--color-surface);
  border: 1px solid rgba(56, 189, 248, 0.15);
  border-radius: var(--radius-lg);
  padding: var(--sp-5);
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
}

.aiPanelHeader {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
}

.aiPanelIcon {
  font-size: 16px;
  color: rgba(56, 189, 248, 0.5);
}

.aiPanelTitle {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--color-sky);
}

.aiPrompts {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
}

.aiPromptBtn {
  font-size: 13px;
  padding: var(--sp-2) var(--sp-4);
  border-radius: 999px;
  background: rgba(56, 189, 248, 0.06);
  border: 1px solid rgba(56, 189, 248, 0.18);
  color: var(--color-text-muted);
  cursor: pointer;
  text-align: left;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  line-height: 1.5;
}

.aiPromptBtn:hover {
  background: rgba(56, 189, 248, 0.14);
  border-color: rgba(56, 189, 248, 0.35);
  color: var(--color-sky);
}

.historyEmpty {
  padding: var(--sp-6) var(--sp-4);
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--color-text-faint);
  text-align: center;
  border: 1px dashed var(--color-border);
  border-radius: var(--radius);
}

/* ── Sync schedule bar ──────────────────────────────────────── */
.scheduleBar {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  padding: var(--sp-3) var(--sp-5);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: 13px;
  flex-wrap: wrap;
}
.scheduleIcon { color: var(--color-text-faint); font-size: 14px; }
.scheduleText { color: var(--color-text-muted); }
.scheduleText strong { color: var(--color-text); font-weight: 600; }
.scheduleSep  { color: var(--color-text-faint); }
.scheduleNext { font-family: var(--font-mono); font-size: 12px; color: var(--color-text-faint); }
.scheduleEditBtn {
  margin-left: auto; font-family: var(--font-mono); font-size: 11px;
  padding: 3px 10px; border-radius: var(--radius-sm);
  background: transparent; border: 1px solid var(--color-border);
  color: var(--color-text-muted); cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
}
.scheduleEditBtn:hover { border-color: var(--color-border-med); color: var(--color-text); }
.scheduleEditPanel { display: flex; flex-direction: column; gap: var(--sp-3); width: 100%; }
.scheduleEditLabel {
  font-family: var(--font-mono); font-size: 10px; font-weight: 600;
  letter-spacing: 2px; text-transform: uppercase; color: var(--color-text-muted);
}
.scheduleOptions { display: flex; flex-wrap: wrap; gap: var(--sp-2); }
.scheduleOption {
  display: flex; align-items: center; gap: var(--sp-2);
  padding: var(--sp-2) var(--sp-3);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  font-size: 13px; color: var(--color-text-muted);
  cursor: pointer; transition: border-color 0.15s, background 0.15s;
}
.scheduleOption:has(input:checked) {
  border-color: rgba(56, 189, 248, 0.35);
  background: rgba(56, 189, 248, 0.05);
  color: var(--color-text);
}
.scheduleOption input { accent-color: var(--color-sky); }
.scheduleCron { font-family: var(--font-mono); font-size: 10px; color: var(--color-text-faint); margin-left: var(--sp-1); }
.scheduleActions { display: flex; gap: var(--sp-2); }
.scheduleSaveBtn {
  font-family: var(--font-mono); font-size: 11px; padding: 3px 12px;
  border-radius: var(--radius-sm); background: rgba(56, 189, 248, 0.1);
  border: 1px solid rgba(56, 189, 248, 0.25); color: var(--color-sky); cursor: pointer;
  transition: background 0.15s;
}
.scheduleSaveBtn:hover { background: rgba(56, 189, 248, 0.18); }
.scheduleSaveBtn:disabled { opacity: 0.5; cursor: default; }
.scheduleCancelBtn {
  font-family: var(--font-mono); font-size: 11px; padding: 3px 10px;
  border-radius: var(--radius-sm); background: transparent;
  border: 1px solid var(--color-border); color: var(--color-text-faint); cursor: pointer;
}

/* ── Field policy (PII/PCI scrubbing) ───────────────────────────────────── */
.fieldPolicySection {
  margin-bottom: var(--sp-4);
  border: 1px solid rgba(251, 191, 36, 0.3);
  border-radius: var(--radius);
  background: rgba(251, 191, 36, 0.04);
  padding: var(--sp-3) var(--sp-4);
}
.fieldPolicyHeader {
  display: flex; align-items: flex-start; gap: var(--sp-3); margin-bottom: var(--sp-3);
}
.fieldPolicyIcon { font-size: 18px; color: #f59e0b; flex-shrink: 0; margin-top: 1px; }
.fieldPolicyTitle { font-size: 13px; font-weight: 600; color: #f59e0b; margin-bottom: 2px; }
.fieldPolicySubtitle { font-size: 12px; color: var(--color-text-muted); }
.fieldPolicyTable {
  width: 100%; border-collapse: collapse; font-size: 12px; margin-bottom: var(--sp-3);
}
.fieldPolicyTable th {
  text-align: left; padding: 4px 8px; color: var(--color-text-faint);
  border-bottom: 1px solid var(--color-border); font-weight: 500;
}
.fieldPolicyTable td { padding: 5px 8px; border-bottom: 1px solid rgba(255,255,255,0.04); }
.fieldPolicyExcludeCol { width: 64px; text-align: center; }
.fieldPolicyRowExcluded td { opacity: 0.6; text-decoration: line-through; }
.fieldPolicyRowExcluded .fieldPolicyExcludeCol { opacity: 1; text-decoration: none; }
.fieldPolicySignal {
  font-family: var(--font-mono); font-size: 11px;
  color: var(--color-text-faint); background: rgba(0,0,0,0.2);
  padding: 1px 5px; border-radius: 3px; display: inline-block;
}
.fieldPolicyActions { display: flex; align-items: center; gap: var(--sp-3); flex-wrap: wrap; }
.fieldPolicySaveBtn {
  font-family: var(--font-mono); font-size: 11px; padding: 4px 14px;
  border-radius: var(--radius-sm); background: rgba(251, 191, 36, 0.12);
  border: 1px solid rgba(251, 191, 36, 0.3); color: #f59e0b; cursor: pointer;
  transition: background 0.15s;
}
.fieldPolicySaveBtn:hover { background: rgba(251, 191, 36, 0.2); }
.fieldPolicySaveBtn:disabled { opacity: 0.5; cursor: default; }
.fieldPolicySavedMsg { font-size: 12px; color: var(--color-green, #4ade80); }
.fieldPolicyResyncNote { font-size: 11px; color: var(--color-text-faint); }
.fieldPolicyError { font-size: 12px; color: var(--color-error, #f87171); }
